import { render, staticRenderFns } from "./OnlineVotingRegistrationForms.vue?vue&type=template&id=72836210&"
import script from "./OnlineVotingRegistrationForms.vue?vue&type=script&lang=js&"
export * from "./OnlineVotingRegistrationForms.vue?vue&type=script&lang=js&"
import style0 from "./OnlineVotingRegistrationForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports